export function useMenus() {
	const route = useRoute();
	const hideCalc = computed(() => route?.query?.withoutacalc === 'true');

	const menus = computed(() => {
		return [
			{ title: 'Калькулятор', path: '/#calc', hide: hideCalc.value },
			{ title: 'О нас', path: '/#about' },
			{ title: 'Этапы работы', path: '/#stage' },
			{ title: 'Контакты', path: '/#contact' },
		].filter((v) => !v.hide);
	});

	return { menus };
}
